import { registerPlugin } from '@capacitor/core';

export interface FirebaseConfigPlugin {
  setEnvironment(options: { environment: 'staging' | 'production' }): Promise<void>;
  getEnvironment(): Promise<{ environment: string }>;
}

export default registerPlugin<FirebaseConfigPlugin>('FirebaseConfig', {
  web: () =>
    ({
      setEnvironment: async () => {},
      getEnvironment: async () => ({ environment: 'production' }),
    }) as FirebaseConfigPlugin,
});
